// import { GetEventsParams, GetEventsResponse } from '@/types/events';
import apiSlice from './apiSlice';
import {
  PendingMarketsResponse,
  RollbackMarketsResponse,
  GetRollbackMarketsParams,
  // CompetitionsResponse,
} from '@/types/pendingMarket';

export const pendingMarketsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // PENDING MARKETS
    getPendingMarkets: builder.query<
      PendingMarketsResponse,
      {
        page?: number;
        limit?: number;
        fromDate?: string;
        toDate?: string;
        search?: string;
        eventId?: number;
        sport?: string;
      }
    >({
      query: ({ page = 1, limit = 10, fromDate, toDate, search, eventId, sport }) => {
        const params = new URLSearchParams();
        const trimmedSearch = search?.trim() ?? '';

        params.append('page', String(page));
        params.append('limit', String(limit));

        if (fromDate) params.append('fromDate', fromDate);
        if (toDate) params.append('toDate', toDate);
        if (search) params.append('search', trimmedSearch);
        if (eventId) params.append('eventId', String(eventId));
        if (sport) params.append('sport', String(sport));

        return {
          url: `/bet-result/pending/markets?${params.toString()}`,
          method: 'GET',
        };
      },
      providesTags: ['PendingMarkets'],
    }),

    // ROLLBACK MARKETS
    getRollbackMarkets: builder.query<PendingMarketsResponse, GetRollbackMarketsParams>({
      query: ({ page = 1, limit = 10, fromDate, toDate, search, eventId, sport }) => {
        const params = new URLSearchParams();
        const trimmedSearch = search?.trim() ?? '';

        params.append('page', String(page));
        params.append('limit', String(limit));
        if (fromDate) params.append('fromDate', fromDate);
        if (toDate) params.append('toDate', toDate);
        if (search) params.append('search', trimmedSearch);
        if (eventId) params.append('eventId', String(eventId));
        if (sport) params.append('sport', String(sport));

        return {
          url: `/bet-result/rollback/markets${params.toString() ? `?${params.toString()}` : ''}`,
          method: 'GET',
          params: { t: Date.now() },
        };
      },

      transformResponse: (response: RollbackMarketsResponse): PendingMarketsResponse => {
        return {
          success: response.success,
          message: response.message,
          pagination: response.pagination,
          markets: response.markets.map((item) => {
            return {
              eventId: item.eventId ?? '',
              eventName: item.eventName ?? '',
              marketId: item.marketId ?? item.marketExternalId ?? '',
              marketName: item.marketName ?? '',
              marketCategory: item.marketCategory ?? null,
              eventExternalId: item.eventExternalId ?? '',
              marketType: item.marketType?.toUpperCase() ?? 'FANCY',
              placedAt: item.createdAt ?? '',
              result: item.result ?? '-',
              selection: item.selection ?? item.selectionId ?? '',
            };
          }),
        };
      },
      providesTags: ['RollbackMarkets'],
    }),

    // EVENTS
    // getEvents: builder.query<GetEventsResponse, GetEventsParams>({
    //   query: (params) => ({
    //     url: '/events',
    //     method: 'GET',
    //     params,
    //   }),
    //   providesTags: ['Events'],
    // }),

    // COMPETITIONS
    // getCompetitionById: builder.query<CompetitionsResponse, string>({
    //   query: (sportName) => ({
    //     url: `/competitions?sport=${sportName}`,
    //     method: 'GET',
    //     params: { t: Date.now() },
    //   }),
    //   providesTags: ['Competitions'],
    // }),
  }),
});

export const {
  useGetPendingMarketsQuery,
  useGetRollbackMarketsQuery,
  // useGetEventsQuery,
  // useLazyGetEventsQuery,
  // useGetCompetitionByIdQuery,
} = pendingMarketsApi;
